<template>
  <div>
    <div class="hcenter">
      <i style="margin-bottom: 10px" @click="back" class="el-icon-arrow-left"></i>
      <div style="width: 200px; margin-bottom: 10px; margin-right: 10px">
        <el-input :value="$route.query.plantationName" disabled />
      </div>
      <SearchComponent
        :selectOrInputList="selectOrInputList"
        @on-search="handleSearch"
        @on-reset="handleReset"
        :authIdentity="authIdentity"
      ></SearchComponent>
    </div>

    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      summary
      :summary-method="summaryMethod"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
      :cell-style="cellStyle"
    >
      <template slot="solts" slot-scope="scope">
        <el-button class="button" type="text" size="small" @click="onOperat('preview', scope.data)">详情</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="operatDialog.title"
      :visible.sync="operatDialog.visible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="operatDialog.visible = false"
    >
      <component
        :ref="operatDialog.currentView"
        :is="operatDialog.currentView"
        :data="operatDialog.data"
        :type="operatDialog.type"
      ></component>
      <span slot="footer"> </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/procure/plan/components/form'
import Preview from './components/Preview'

import { getSkinDetailList } from '@/api/manage/report'

import { isDef } from '@/utils/is'
export default {
  name: 'skinDetail',
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
    Preview,
  },
  data() {
    const _this = this
    const title = '出皮统计'

    return {
      authIdentity: 'process:skin',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'bizNo',
          label: '采摘批次',
          isTrue: true,
        },
        {
          prop: 'pickTraceabilityNodeTime',
          label: '采摘日期',
          isTrue: true,
          formatter(row) {
            return row.pickTraceabilityNodeTime ? _this.parseTime(row.pickTraceabilityNodeTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: '',
          label: '鲜果规格',
          isTrue: true,
          formatter(row) {
            const arr = [
              row.ripenessLevelSpecAttrValueKey,
              row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
              row.cultivationMethodSpecValueKey,
            ]
            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: 'freshFruitTotalNetWeight',
          label: '鲜果验收总净重（斤）',
          isTrue: true,
          width: '120',
        },
        {
          prop: 'freshPeelTotalNetWeight',
          label: '鲜皮总净重（斤）',
          width: '120',
          isTrue: true,
        },
        {
          prop: '',
          label: '鲜皮率（%）',
          isTrue: true,
          formatter(row) {
            return _this.myFixed(row.freshPeelRate, 2)
          }
        },
        {
          prop: '',
          label: '生产加工日期',
          isTrue: true,
          formatter(row) {
            return row.freshTraceabilityNodeTime ? _this.parseTime(row.freshTraceabilityNodeTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: 'dryBizNo',
          label: '干皮批次',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'createTime',
          label: '干皮规格',
          isTrue: true,
          width: '100',
          formatter(row) {
            const arr = [
              row.ripenessLevelSpecAttrValueKey,
              row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
              _this.parseTime(row.freshTime, '{y}'),
              row.cultivationMethodSpecValueKey,
              row.name,
            ]
            return arr.filter((item) => !!item).join('-')
          },
        },

        {
          prop: 'totalNetWeight',
          label: '干皮总净重（斤）',
          isTrue: true,
          width: '120',
        },
        {
          prop: '',
          label: '出皮率（%）',
          isTrue: true,
          width: '90',
          formatter(row) {
            return _this.myFixed(row.peelRate, 2)
          }
        },
        {
          prop: '',
          label: '干皮生产日期',
          isTrue: true,
          width: '90',
          formatter(row) {
            return row.dryTraceabilityNodeTime ? _this.parseTime(row.dryTraceabilityNodeTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'searchValue',
          placeholder: '请输入采摘或干皮批次',
          class: 'home',
          type: 'input',
        },
      ],

      // 弹窗数据
      operatDialog: {
        visible: false, // 是否展示
        title: '', // 弹窗标题
        currentView: null, //当前组件
        width: '', // 弹窗宽度
        type: '', // 提交类型
        data: {}, // 数据
      },

      // 弹窗枚举
      operatEnum: {
        add: () => {
          return {
            component: 'MForm',
            title: `新增${title}`,
            width: '75%',
          }
        },
        edit: () => {
          return {
            component: 'MForm',
            title: `修改${title}`,
            width: '75%',
          }
        },
        preview: () => {
          return {
            component: 'Preview',
            title: `查看${title}`,
            width: '75%',
          }
        },
        resubmit: () => {
          return {
            component: 'MFrom',
            title: `重新提交${title}`,
            width: '75%',
          }
        },
        submit: () => {
          return {
            component: 'Preview',
            title: `提交${title}`,
            width: '75%',
          }
        },
      },

      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getSkinDetailList({ ...this.queryParams, plantationId: this.$route.query.plantationId })
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (
        isDef(row.freshPeelMaxFairValue) &&
        isDef(row.freshPeelMinFairValue) &&
        isDef(row.freshPeelRate) &&
        (row.freshPeelRate > row.freshPeelMaxFairValue || row.freshPeelRate < row.freshPeelMinFairValue) &&
        [6].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      } else if (
        isDef(row.dryPeelMaxFairValue) &&
        isDef(row.dryPeelMinFairValue) &&
        isDef(row.peelRate) &&
        (row.peelRate > row.dryPeelMaxFairValue || row.peelRate < row.dryPeelMinFairValue) &&
        [11].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      }
    },
    // 操作: add添加，edit编辑，import导入, export导出, print打印
    onOperat(type, row) {
      // 添加操作类型
      const { component, title, width } = this.operatEnum[type]()
      this.operatDialog.title = title
      this.operatDialog.width = width
      this.operatDialog.type = type
      this.operatDialog.data = row || {}

      this.operatDialog.currentView = component
      this.operatDialog.visible = true
    },
    summaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 4) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshFruitTotalNetWeight || 0), 2)
          }, 0) || '-'
          return
        }
        if (index == 5) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshPeelTotalNetWeight || 0), 2)
          }, 0) || '-'
          return
        }
        if (index == 6) {
          const freshPeelTotalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshPeelTotalNetWeight || 0), 2)
          }, 0)

          const freshFruitTotalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshFruitTotalNetWeight || 0), 2)
          }, 0)

          sums[index] = !freshFruitTotalNetWeight
            ? (freshFruitTotalNetWeight || '-')
            : (this.myFixed((freshPeelTotalNetWeight / freshFruitTotalNetWeight) * 100, 2)  || '-')
          return
        }
        if (index == 10) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)  || '-'
          return
        }
        if (index == 11) {
          const totalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)

          const processingFreshNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.processingFreshNetWeight || 0), 2)
          }, 0)

          sums[index] = !processingFreshNetWeight
            ? (processingFreshNetWeight || '-')
            : (this.myFixed((totalNetWeight / processingFreshNetWeight) * 100, 2) || '-')
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    back() {
      this.$router.back()
    },
    toDetail() {
      this.$router.push('/')
    },
    handlePrint(row) {
      this.printInfo.list = [row]

      this.printInfo.printDialog = true
      this.$nextTick(() => {
        this.$refs.printBox.init(this.printInfo)
      })
    },
    cancel() {
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'myform'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
// @import '../../../../assets/form.less';
@import '~@/assets/variables.less';
.el-icon-arrow-left {
  font-size: 30px;
  color: @theme-color;
  cursor: pointer;
}

.hcenter {
  display: flex;
  align-items: center;
}
</style>
